import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { apiurl } from "../config/config";
import EmailInputField from "./emailInputField";

const backdrop = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
};

const modal = {
  hidden: { y: "-100vh", opacity: 0 },
  visible: { y: "0", opacity: 1, transition: { delay: 0.1 } },
};

const ReportModal = ({ show, onClose, onSend, startDate, endDate }) => {
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState({
    allTime: [],
    datewise: [],
    referenceBreakdown: [],
  });
  const [reportDataAll, setReportDataAll] = useState({
    totalApplications: 0,
    totalSelected: 0,
    throughConsultancy: 0,
    throughWalkins: 0,
    throughRecruitmentTeam: 0,
    throughEmployeeReference: 0,
    throughOther: 0,
    totalNotSelected: 0,
  });

    const [error, setError] = useState("");
    const [uploading, setUploading] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    
    const [emailData, setEmailData] = useState({
      ccEmails: [],
      subject: "",
      message: "",
      toEmails: [],
      attachment:""
    });

  const handleFileUpload = async (e, field) => {
    console.log("Uploading field:", field);
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadMessage("");

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${apiurl}/api/media/interview-tracker`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response?.data?.success) {
        console.log("Upload response:", response);
        // setFormData((prev) => ({
        //   ...prev,
        //   [field]: response.data.fileUrl, // Ensure correct field is updated
        // }));

        setEmailData((prev) => ({
          ...prev,
          attachment: response.data.fileUrl,
        }));
        

        setUploadMessage("File uploaded successfully!");
      } else {
        setUploadMessage("File upload failed. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadMessage("Error uploading file.");
    } finally {
      setUploading(false);
    }
  };


  const sendEmailReport = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiurl}/api/analytic/send-interview-report`,
        {
          toEmails: emailData.toEmails,
          ccEmails: emailData.ccEmails,
          subject: emailData.subject,
          message: emailData.message,
          attachment: emailData.attachment,
          data: {
            // positionTitle: "Sales Executive",
            totalAppeared: reportDataAll.totalApplications,
            totalSelected: reportDataAll.totalSelected,
            totalRejected: reportDataAll.totalNotSelected,
            sourceStats: {
              consultants: reportDataAll.throughConsultancy,
              walkins: reportDataAll.throughWalkins,
              recruitmentTeam: reportDataAll.throughRecruitmentTeam,
              employeeRef: reportDataAll.throughEmployeeReference,
              other: reportDataAll.throughOther,
            },
            recruiterStats: reportData.referenceBreakdown,
          },
        }
      );
      alert("✅ Report sent successfully!");
      onClose(); // Close modal after sending
    } catch (err) {
      console.error("Failed to send report:", err);
      alert("❌ Failed to send report.");
    } finally {
      setLoading(false);
    }
  };

  console.log("emailData:", emailData);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${apiurl}/api/analytic/reports/reference-leaderboard-datewise?startDate=${startDate}&endDate=${endDate}`
        );
        const data = res.data;
        setReportData({
          allTime: data.report.allTime || [],
          datewise: data.report.datewise || [],
          referenceBreakdown: data.report.referenceBreakdown || [],
        });
        setReportDataAll({
          totalApplications: data?.report?.totalApplications || 0,
          totalSelected: data?.report?.totalSelected || 0,
          throughConsultancy: data?.report?.throughConsultancy || 0,
          throughWalkins: data?.report?.throughWalkins || 0,
          throughRecruitmentTeam: data?.report?.throughRecruitmentTeam || 0,
          throughEmployeeReference: data?.report?.throughEmployeeReference || 0,
          throughOther: data?.report?.throughOther || 0,
          totalNotSelected: data?.report?.totalNotSelected || 0,
        });
      } catch (err) {
        console.error("Error fetching report:", err);
        setReportData({ allTime: [], datewise: [], referenceBreakdown: [] });
        setReportDataAll({
          totalApplications: 0,
          totalSelected: 0,
          throughConsultancy: 0,
          throughWalkins: 0,
          throughRecruitmentTeam: 0,
          throughEmployeeReference: 0,
          throughOther: 0,
          totalNotSelected: 0,
        });
      } finally {
        setLoading(false);
      }
    };

    if (show) fetchData();
  }, [show, startDate, endDate]);

  const renderSummaryRow = (label, value) => (
    <div className="flex justify-between">
      <span className="font-semibold">{label}:</span>
      <span>{value}</span>
    </div>
  );

  const renderTable = (data) => (
    <div className="overflow-x-auto mt-2">
      <table className="min-w-full text-sm text-left border rounded-md overflow-hidden">
        <thead className="bg-indigo-100 font-semibold text-indigo-800">
          <tr>
            <th className="px-4 py-2 border">#</th>
            <th className="px-4 py-2 border">Name</th>
            <th className="px-4 py-2 border">Employee ID</th>
            <th className="px-4 py-2 border">Total</th>
            <th className="px-4 py-2 border">Selected</th>
            <th className="px-4 py-2 border">Rejected</th>
            <th className="px-4 py-2 border">Offered</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, idx) => (
              <tr key={idx} className="odd:bg-white even:bg-gray-50">
                <td className="px-4 py-2 border">{idx + 1}</td>
                <td className="px-4 py-2 border">{item.name || "N/A"}</td>
                <td className="px-4 py-2 border">
                  {item.referenceId || "N/A"}
                </td>
                <td className="px-4 py-2 border">{item.total || 0}</td>
                <td className="px-4 py-2 border text-green-700">
                  {item.selected || 0}
                </td>
                <td className="px-4 py-2 border text-red-600">
                  {item.rejected || 0}
                </td>
                <td className="px-4 py-2 border text-green-600">
                  {item.offered || 0}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 py-4">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50 flex items-center justify-center"
          variants={backdrop}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={onClose}
        >
          <motion.div
            className="bg-white rounded-2xl p-6 w-full max-w-4xl shadow-xl relative overflow-y-auto max-h-[90vh]"
            variants={modal}
            initial="hidden"
            animate="visible"
            exit="hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-2xl font-bold text-indigo-700 mb-4">
              📧 Send Recruiter Report
            </h3>

            {loading ? (
              <div className="text-center py-8 text-gray-600 font-medium">
                <div className="animate-spin h-5 w-5 mx-auto mb-2 border-4 border-indigo-300 border-t-transparent rounded-full" />
                Fetching report...
              </div>
            ) : (
              <div className="space-y-6">
                <div>
                  <h4 className="text-lg font-semibold text-indigo-600">
                    Report Summary
                  </h4>
                  <div className="space-y-3">
                    {renderSummaryRow(
                      "Total Applications",
                      reportDataAll.totalApplications
                    )}
                    {renderSummaryRow(
                      "Total Selected",
                      reportDataAll.totalSelected
                    )}
                    {renderSummaryRow(
                      "Through Consultancy",
                      reportDataAll.throughConsultancy
                    )}
                    {renderSummaryRow(
                      "Through Walkins",
                      reportDataAll.throughWalkins
                    )}
                    {renderSummaryRow(
                      "Through Recruitment Team",
                      reportDataAll.throughRecruitmentTeam
                    )}
                    {renderSummaryRow(
                      "Through Employee Reference",
                      reportDataAll.throughEmployeeReference
                    )}
                    {renderSummaryRow(
                      "Through Other",
                      reportDataAll.throughOther
                    )}
                    {renderSummaryRow(
                      "Total Not Selected",
                      reportDataAll.totalNotSelected
                    )}
                  </div>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-indigo-600">
                    Reference Breakdown
                  </h4>
                  {renderTable(reportData.referenceBreakdown)}
                </div>
              </div>
            )}

            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
              className="space-y-4 mt-6 border-t pt-6"
            >
              <div className="flex flex-col w-full justify-between items-center">
                <EmailInputField
                  label="To Email *"
                  value={emailData.toEmails}
                  onChange={(newList) =>
                    setEmailData((prev) => ({ ...prev, toEmails: newList }))
                  }
                />

                <EmailInputField
                  label="CC Email"
                  value={emailData.ccEmails}
                  onChange={(newList) =>
                    setEmailData((prev) => ({ ...prev, ccEmails: newList }))
                  }
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Subject
                </label>
                <input
                  type="text"
                  value={emailData.subject}
                  onChange={(e) =>
                    setEmailData((prev) => ({
                      ...prev,
                      subject: e.target.value,
                    }))
                  }
                  className="w-full border border-gray-300 px-4 py-2 rounded-md"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  value={emailData.message}
                  onChange={(e) =>
                    setEmailData((prev) => ({
                      ...prev,
                      message: e.target.value,
                    }))
                  }
                  rows={3}
                  className="w-full border border-gray-300 px-4 py-2 rounded-md"
                />
              </div>

              <h3 className="text-md font-semibold mt-8 mb-4">
                Upload Attachment
              </h3>
              <input
                type="file"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.xlsx,.xls"
                onChange={(e) => handleFileUpload(e, "attachment")}
                className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />

              {uploading && <p className="text-blue-500">Uploading...</p>}
              {uploadMessage && (
                <p className="text-green-500">{uploadMessage}</p>
              )}

              <div className="flex justify-end">
                <button
                  className="w-full bg-indigo-600 text-white py-2 mt-4 rounded-md"
                  onClick={sendEmailReport}
                >
                  {loading ? "Sending..." : "Send Report"}
                </button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ReportModal;
